import React from 'react';

export default function CreativeAssignmentResults({ report }) {
  if (!report) return null;
  const platform = report.provider === 'facebook' ? 'Meta' : 'Search';
  return <section className="creative-package-review" aria-label={`${platform} ad assignment results`}>
    <h3>{report.confirmed_ads} of {report.expected_ads} approved {platform} ads confirmed</h3>
    {report.confirmed_ads !== report.expected_ads && <p>Some ads remain unconfirmed or were not attempted. Inspect the existing campaign before making another creation request.</p>}
    {report.unexpected_ads > 0 && <p>{report.unexpected_ads} additional ad results could not be matched to the approved source. Inspect the campaign before continuing.</p>}
    {report.ads.map(ad => <p key={`${ad.group}/${ad.ad_id}`}>
      <strong>{ad.group} / {ad.ad_id}</strong> · {ad.status.replaceAll('_', ' ')}
      {ad.ad_resource_name && <> · <span>{ad.ad_resource_name}</span></>}
      {ad.platform_ad_id && <> · Ad {ad.platform_ad_id}</>}
      <br />{ad.lead_gen_form_id ? `Instant Form · ${ad.lead_gen_form_id}` : ad.final_url}
    </p>)}
  </section>;
}
